import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux';
import PropTypes from 'prop-types'
import { Field, reduxForm } from 'redux-form'
import moment from 'moment';

import { X } from 'react-feather';
import { Row, Col } from 'react-flexbox-grid';
import Textfield from '../../signup/components/Textfield';

import * as Validate from '../../../helpers/validations'
import modalStyles from '../styles/createModal.module.scss';
import 'flatpickr/dist/themes/material_blue.css'
import Button from '../../../components/Button';
import { createEvent, deleteEvent } from '../../../actions/events-actions';
import { calendarFunctions } from '../../../helpers/calendar-functions';
import RRuleInput from './RRuleInput';
import Datepicker from '../../../components/Datepicker';
import { ToastsStore } from 'react-toasts';
import ConfirmationModal from '../../../components/ConfirmationModal';
import RecurrenceUpdateModal from '../../../components/RecurrenceUpdateModal';

const uuidv4 = require('uuid/v4')

class ReminderModal extends Component {

    constructor(props) {
        super(props);

        const { originReminder, isEditing } = props;
        let dateFormat = 'F j, Y h:i K';

        const originalReminderIsRecurrent = (isEditing && originReminder.hasOwnProperty('recurrenceRule') && originReminder.recurrenceRule !== '');
        let recurrenceObject = {}, originalRecurrenceObject = {};

        if (originalReminderIsRecurrent) {
            recurrenceObject = calendarFunctions.generateRecurrencyObjectFromString(originReminder.recurrenceRule).options;
            recurrenceObject = {
                freq: recurrenceObject.freq,
                dtstart: recurrenceObject.dtstart,
                interval: recurrenceObject.interval,
                wkst: recurrenceObject.wkst,
                until: recurrenceObject.until
            }

            originalRecurrenceObject = {...recurrenceObject};
        }
        this.state = {
            reminder: {
                id: isEditing ? originReminder.id : uuidv4(),
                title: isEditing ? originReminder.title : '',
                calendarId: 'liveli',
                category: originReminder.category,
                start: moment().clone().toISOString(),
                end: moment().clone().add(1, 'minute').toISOString(),
                rUntilDate: (originReminder.raw && originReminder.raw.rUntilDate) ? originReminder.raw.rUntilDate : '',
                isReminder: true,
                recurrenceRule: isEditing ? originReminder.recurrenceRule : '',
                reminderDate:  isEditing ? moment(originReminder.start).clone().toISOString() :  moment().clone().toISOString(),
            },
            recurrenceObject,
            datePickerKeys: {
                startDate: uuidv4(),
                rrule: uuidv4()
            },
            rUntilDate: (originReminder.raw && originReminder.raw.rUntilDate) ? originReminder.raw.rUntilDate : '',
            dateFormat,
            isEditing,
            editionEnabled: false,
            showConfirmDeleteModal: false,
            showRecurrenceUpdateModal: false,
            showRecurrenceDeleteModal: false,
            showDeleteToast: true,
            timeChanged: false,
            dateChanged: false,
            frequencyOrUntilDateChanged: false,
            shouldKeepUntil: false,
            allAndFuture: false,
            showAll: true,
            thisOnly: true,
            reminderChanged: false,
            recurrenceChanged: false,
            originalReminderIsRecurrent,
            originalRecurrenceObject
        }
        this.escFunction = this.escFunction.bind(this);
    }

    reminderOptions = [
        { value: 'minutes', label: 'Minutes'},
        { value: 'hours', label: 'Hours'},
        { value: 'days', label: 'Days'},
        { value: 'weeks', label: 'Weeks'}
    ]

    componentDidUpdate(prevProps) {
        if (prevProps.saving && !this.props.saving && this.props.updateEventsSuccess) {
            this.props.onClose();
            ToastsStore.success(this.props.isEditing ? 'Reminder Updated' : 'Reminder Saved');
        }

        if (!this.props.deleting && prevProps.deleting && this.props.deleteEventsSuccess && this.state.showDeleteToast) {
            this.props.onClose();
            ToastsStore.success('Reminder Deleted');
        }
    }

    componentDidMount() {
        this.initializeDatePickers();

        if (this.props.isEditing) {
            const { originReminder } = this.props;
            this.props.initialize({
                title: originReminder.title
            })
        }
        document.addEventListener("keydown", this.escFunction, false);
    }
    componentWillUnmount(){
        document.removeEventListener("keydown", this.escFunction, false);
    }

    escFunction(event) {
        if (event.keyCode === 27) {
            if(!this.state.showConfirmDeleteModal) {
                this.props.onClose();
            }
        }
    }

    initializeDatePickers = () => {
        const { originReminder } = this.props;

        const start = moment(originReminder.start.toDate());

        this.setState(state => {
            return {
                reminder: {
                    ...state.reminder,
                    start: start.toISOString(),
                    end: start.clone().add(1, 'minute'),
                    reminderDate: start.toISOString()
                }
            }
        })
    }

    toggleEdition = () => {
        this.setState({
            editionEnabled: !this.state.editionEnabled,
            datePickerKeys: {
                ...this.state.datePickerKeys,
                startDate: uuidv4()
            }
        })
    }

    onDelete = () => {
        const { originReminder } = this.props;
        if (originReminder.recurrenceRule) {
            let allAndFuture = originReminder.raw.isLastRepetition ? false : true;
            this.setState({
                showRecurrenceDeleteModal: true,
                allAndFuture
            });
        } else {
            this.setState({
                showConfirmDeleteModal: true
            })
        }
    }

    closeEventDeletionModal = () => this.setState({showConfirmDeleteModal: false})

    closeRecurrenceDeleteModal = () => this.setState({showRecurrenceDeleteModal: false})

    closeRecurrenceUpdateModal = () => this.setState({showRecurrenceUpdateModal: false})

    updateStartDate = (dateString) => {
        const startDate = moment(dateString);
        let dateChanged = false, timeChanged = false, shouldKeepUntil = false;
        if (this.props.isEditing && this.state.originalReminderIsRecurrent) {
            const origStartDate = moment(this.props.originReminder.start.toDate());
            switch (true) {
                case !origStartDate.isSame(startDate, 'date') && !origStartDate.isSame(startDate, 'month'):
                case !origStartDate.isSame(startDate, 'date') && origStartDate.isSame(startDate, 'month'):
                case !origStartDate.isSame(startDate, 'year'):
                    dateChanged = true;
                    break;
                default:
                    break;
            }
            timeChanged = !dateChanged && (!origStartDate.isSame(startDate, 'hours') || !origStartDate.isSame(startDate, 'minutes'));
            shouldKeepUntil = true;
        }
        this.setState(state => {
            return {
                reminder: {
                    ...state.reminder,
                    start: startDate.toISOString(),
                    end: startDate.clone().add(1, 'minute').toISOString(),
                    reminderDate: startDate.toISOString()
                },
                reminderChanged: true,
                dateChanged,
                timeChanged,
                shouldKeepUntil,
                datePickerKeys: {
                    ...state.datePickerKeys
                }
            }
        })
    }

    onChangeEventAttribute = (event) => {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState(state => {
            return {
                reminder: {
                    ...state.reminder,
                    [name]: value
                },
                reminderChanged: true
            }
        })
    }

    onChangeRRule = (recurrenceObject, frequencyOrUntilDateChanged, rUntilDate) => {
        const { originalReminderIsRecurrent, originalRecurrenceObject } = this.state;

        let reminderChanged = false, recurrenceChanged = false;
        if (originalReminderIsRecurrent && recurrenceObject.dtstart) {
            switch (true) {
                case !moment(originalRecurrenceObject.dtstart).isSame(moment(recurrenceObject.dtstart)):
                case !moment(originalRecurrenceObject.until).isSame(moment(recurrenceObject.until)):
                case originalRecurrenceObject.freq !== recurrenceObject.freq:
                case originalRecurrenceObject.interval !== recurrenceObject.interval:
                    recurrenceChanged = frequencyOrUntilDateChanged ? true : false;
                    reminderChanged = true;
                    break;
                default:
                    break;
            }
        } else if (originalReminderIsRecurrent && !recurrenceObject.hasOwnProperty('dtstart')) {
            reminderChanged = true;
        } else if (!originalReminderIsRecurrent && recurrenceObject.dtstart && this.props.isEditing) {
            reminderChanged = true;
        }
        this.setState({
            recurrenceObject,
            recurrenceChanged,
            reminderChanged,
            rUntilDate
        });
    }

    deleteRecurrentEvent = (action, showDeleteToast = true) => {
        const { originReminder } = this.props;
        let events = [], sortKey = 'recurrentEvents';

        switch (action) {
            case 'all':
                events = calendarFunctions.removeAllRecurrencyEvents(this.props.recurrentEvents, originReminder);
                break;
            case 'this':
                events = calendarFunctions.removeUniqueEventInRecurrence(this.props.recurrentEvents, originReminder);
                break;
            case 'future':
                events = calendarFunctions.removeEventAndFuture(this.props.recurrentEvents, originReminder);
                break;
            default:
                break;
        }

        const data = {
            email: this.props.user.email,
            sortKey,
            events,
            create: false
        }

        this.setState({
            showDeleteToast
        }, () => this.props.deleteEvent(data, 'recurrent'))
    }

    deleteSingleEvent = (showDeleteToast = true) => {
        const { originReminder, events } = this.props;
        const sortKey = moment(originReminder.start.toDate()).format('YYYY-MM');
        const newEvents = calendarFunctions.removeEvent(events, originReminder);
        const isReminder = calendarFunctions.isReminder(events, originReminder);

        const data = {
            email: this.props.user.email,
            sortKey,
            events: calendarFunctions.removeCalendarProps(newEvents),
            create: false,
            viewSortKey: undefined,
            isReminder,
        }

        this.setState({
            showDeleteToast
        }, () => this.props.deleteEvent(data))
    }

    proceedToEditRecurrent = (updatedEvent) => {
        const { originReminder } = this.props;
        const allAndFuture = originReminder.raw.isLastRepetition && !this.state.recurrenceChanged ? false : true;
        const showAll = this.state.dateChanged ? false : true;
        const thisOnly = this.state.recurrenceChanged ? false : true;
        this.setState({
            showRecurrenceUpdateModal: true,
            reminder: updatedEvent,
            allAndFuture,
            showAll,
            thisOnly
        })
    }

    updateRecurrentEvent = (action) => {
        const { reminder, recurrenceObject, recurrenceChanged } = this.state;
        const { recurrentEvents, originReminder } = this.props;
        let events = [], sortKey = 'recurrentEvents';
        let newRecurrentEvents = [];

        switch (action) {
            case 'all':
                if (recurrenceChanged) {
                    reminder.recurrenceRule = calendarFunctions.generateRRule(recurrenceObject).toString();
                }
                events = calendarFunctions.updateAllRecurrencyEvents(recurrentEvents, originReminder.raw.parentEventId, reminder, recurrenceChanged);
                break;
            case 'this':
                if (recurrenceChanged) {
                    recurrenceObject.dtstart = moment(reminder.start).toDate();
                    reminder.recurrenceRule = calendarFunctions.generateRRule(recurrenceObject).toString();
                    newRecurrentEvents = calendarFunctions.removeUniqueEventInRecurrence(recurrentEvents, originReminder);
                    reminder.id = uuidv4();
                    events = calendarFunctions.putNewRecurrentEvent(newRecurrentEvents, reminder);
                } else {
                    events = calendarFunctions.updateUniqueEventInRecurrency(recurrentEvents, originReminder, reminder);
                }
                break;
            case 'future':
                newRecurrentEvents = calendarFunctions.removeEventAndFuture(recurrentEvents, originReminder);
                reminder.id = uuidv4();
                recurrenceObject.dtstart= moment(reminder.start).toDate();
                reminder.recurrenceRule = calendarFunctions.generateRRule(recurrenceObject).toString();
                events = calendarFunctions.putNewRecurrentEvent(newRecurrentEvents, reminder);
                break;
            default:
                break;
        }

        const data = {
            email: this.props.user.email,
            sortKey,
            events: calendarFunctions.removeCalendarProps(events),
            create: false
        }

        this.props.createEvent(data);
    }

    onSubmit = () => {
        const { reminder, rUntilDate } = this.state;
        let newReminder = reminder;
        let reminderScheduleId = "isNew";
        let reminderHasChenged = true;
        let sortKey, newEvents = [];

        this.props.events.forEach(ev => {
            if (ev.id === newReminder.id) {
                reminderScheduleId = ev.reminderScheduleId;
                if (ev.start !== newReminder.start || ev.reminderDate !== newReminder.reminderDate.toISOString() )
                    reminderHasChenged = true;
                else 
                    reminderHasChenged = false;
            }
        })

        this.props.recurrentEvents.forEach(recc => {
            if (recc.id === newReminder.id) {
                reminderScheduleId = recc.reminderScheduleId;
                if (recc.start !== newReminder.start || recc.reminderDate !== newReminder.reminderDate.toISOString() )
                    reminderHasChenged = true;
                else 
                    reminderHasChenged = false;
            }
        })

        if (reminderScheduleId !== "isNew")
                newReminder = {
                    ...newReminder,
                    reminderScheduleId,
                    reminderHasChenged
                }
            else 
                newReminder = {
                    ...newReminder,
                    reminderHasChenged: true,
                }

        if (this.state.originalReminderIsRecurrent) {
            const lostRecurrence = !this.state.recurrenceObject.dtstart;
            newReminder.rUntilDate = rUntilDate;
            if (lostRecurrence) {
                sortKey = moment(newReminder.start).format('YYYY-MM');
                newReminder.id = uuidv4();
                newReminder.recurrenceRule = '';
                newEvents.push(newReminder);
                this.deleteRecurrentEvent('all', false);
                this.executeUpdate(sortKey, newEvents, true)
                return;
            }
            this.proceedToEditRecurrent(newReminder);
            return;
        }

        if (!this.state.originalReminderIsRecurrent && this.props.isEditing && this.state.recurrenceObject.dtstart) {
            this.deleteSingleEvent(false)
            sortKey = "recurrentEvents";
            newReminder.recurrenceRule = calendarFunctions.generateRRule(this.state.recurrenceObject).toString();
            newReminder.rUntilDate = rUntilDate;
            newEvents = calendarFunctions.putNewRecurrentEvent(this.props.recurrentEvents, newReminder);
            this.executeUpdate(sortKey, newEvents, false);
            return;
        }

        /**New event is recurrent */
        if (this.state.recurrenceObject.dtstart && !this.props.isEditing) {
            sortKey = "recurrentEvents";
            newReminder.recurrenceRule = calendarFunctions.generateRRule(this.state.recurrenceObject).toString();
            newReminder.rUntilDate = rUntilDate;
            newEvents = calendarFunctions.putNewRecurrentEvent(this.props.recurrentEvents, newReminder);
            this.executeUpdate(sortKey, newEvents, false);
            return;
        } else {
            sortKey = moment(newReminder.start).format('YYYY-MM');

            if (this.props.isEditing) {
                let previousSortKey = moment(this.props.originReminder.start.toDate()).format('YYYY-MM');

                /* If event changed his date it will be inserted as new in another SortKey */
                if (previousSortKey !== sortKey) {
                    // Remove event from original sortKey Events
                    const eventsWithoutUpdated = calendarFunctions.removeEvent(this.props.events, newReminder);
                    this.executeUpdate(previousSortKey, eventsWithoutUpdated, false);

                    // Create event in new SortKey
                    this.executeUpdate(sortKey, [newReminder], true);
                    return;
                } else {
                    newEvents = calendarFunctions.putUpdatedEvent(this.props.events, newReminder)
                }
            } else {
                newEvents.push(newReminder);
            }
        }

        this.executeUpdate(sortKey, newEvents, this.props.isEditing ? false : true)
    }

    executeUpdate = (sortKey, events, create) => {
        const data = {
            email: this.props.user.email,
            sortKey,
            events: calendarFunctions.removeCalendarProps(events),
            create: create,
            viewSortKey: moment(this.props.originReminder.start.toDate()).format('YYYY-MM')
        }

        this.props.createEvent(data)
    }

    isSubmitButtonDisabled = () => {
        const { reminderChanged, isEditing, editionEnabled } = this.state;
        const { invalid, submitting } = this.props;
        const invalidForm = (invalid || submitting);

        if (invalidForm) {
            return true;
        } else if (isEditing && !editionEnabled && !reminderChanged) {
            return false;
        } else if (!isEditing && !invalidForm) {
            return false;
        } else if (isEditing && reminderChanged) {
            return false
        } else {
            return true;
        }
    }

    renderFooterButtons = () => {
        const  { isEditing, editionEnabled } = this.state;
        let firstBtnLabel = 'Cancel', secondBtnLabel = 'Save', onClickFirstBtn = this.props.onClose, isDeleteSecondBtn = false, isLoginSecondBtn = true;
        let showButton = true;

        if (isEditing && editionEnabled) {
            firstBtnLabel = 'Cancel'; secondBtnLabel = 'Update'; onClickFirstBtn = this.toggleEdition; isDeleteSecondBtn = false; isLoginSecondBtn = true;
        } else if (isEditing) {
            firstBtnLabel = 'Edit'; secondBtnLabel = 'Delete'; onClickFirstBtn = this.toggleEdition; isDeleteSecondBtn = true; isLoginSecondBtn = false;
        }

        if (isEditing && this.props.originReminder.calendarId !== 'liveli'){
            firstBtnLabel = 'Ok'
            showButton = false;
            onClickFirstBtn = this.props.onClose
        }

        return (
        <Row end="xs">
            <Col xs={4}>
                <Button
                    label={firstBtnLabel}
                    cancel={true}
                    click={onClickFirstBtn}
                />
            </Col>
            { showButton &&
            <Col xs={4}>
                <Button
                    disabled={this.isSubmitButtonDisabled()}
                    type="submit"
                    delete={isDeleteSecondBtn}
                    login={isLoginSecondBtn}
                    label={secondBtnLabel}
                />
            </Col>}
        </Row>);
    }

    render() {
        const { reminder, isEditing, editionEnabled } = this.state;
        const { handleSubmit } = this.props;
        const enableFields = isEditing === false || (isEditing && editionEnabled);
        return (
            <section id={this.props.id} className={[modalStyles.alertPrompt__background, modalStyles.__active].join(' ')}>
                {this.state.showRecurrenceDeleteModal &&
                    <RecurrenceUpdateModal
                        eventType="reminder"
                        actionType="Delete"
                        onAll={() => this.deleteRecurrentEvent('all')}
                        onThisAndFuture={() => this.deleteRecurrentEvent('future')}
                        onThisOnly={() => this.deleteRecurrentEvent('this')}
                        showThisAndFuture={this.state.allAndFuture}
                        showThisOnly={true}
                        showAll={true}
                        onClose={this.closeRecurrenceDeleteModal}
                    />}
                {this.state.showRecurrenceUpdateModal &&
                    <RecurrenceUpdateModal
                        eventType="reminder"
                        actionType="Update"
                        onAll={() => this.updateRecurrentEvent('all')}
                        onThisAndFuture={() => this.updateRecurrentEvent('future')}
                        onThisOnly={() => this.updateRecurrentEvent('this')}
                        showThisAndFuture={this.state.allAndFuture}
                        showAll={this.state.showAll}
                        showThisOnly={this.state.thisOnly}
                        onClose={this.closeRecurrenceUpdateModal}
                    />}
                {this.state.showConfirmDeleteModal &&
                    <ConfirmationModal
                        title="Delete reminder"
                        label="Confirm reminder deletion?"
                        confirmText="Delete"
                        cancelText="Cancel"
                        onClose={this.closeEventDeletionModal}
                        onConfirm={this.deleteSingleEvent}
                    />}
                <section className={modalStyles.alertPrompt__card}>
                    <header className={modalStyles.alertPrompt__header}>
                        <Row start="xs" between="xs" middle="xs">
                            <Col xs={11}>
                                <h4>
                                    {this.props.title}
                                </h4>
                            </Col>
                            <Col xs={1}>
                                <span className={modalStyles.alertPrompt__close} onClick={this.props.onClose}>
                                    <X size={24} color="#C61C33"/>
                                </span>
                            </Col>
                        </Row>
                    </header>
                    <section className={modalStyles.alertPrompt__form}>
                        <Row center="xs">
                            <Col xs={12}>
                                <form onSubmit={handleSubmit(isEditing ? editionEnabled ?  this.onSubmit : this.onDelete : this.onSubmit)}>
                                    <Field
                                        onChange={this.onChangeEventAttribute}
                                        name="title"
                                        label="title"
                                        props={{
                                            input_type: 'text',
                                            label: 'Title',
                                            disabled:!enableFields
                                        }}
                                        component={Textfield}
                                        validate={[Validate.required]}
                                    />
                                    <Row start="xs" className={modalStyles.row}>
                                        <Col xs={8}>
                                            <Datepicker
                                                datePickerKey={this.state.datePickerKeys.startDate}
                                                label="Reminder Date"
                                                defaultValue={reminder.start}
                                                value={reminder.start}
                                                enableTime={true}
                                                altFormat={this.state.dateFormat}
                                                onChange={this.updateStartDate}
                                                disabled={!enableFields}
                                                // maxDate={this.state.maxStartDate}
                                            />
                                        </Col>
                                    </Row>
                                    <Row start="xs" style={{marginTop: '1rem'}}>
                                        <Col xs={12}>
                                            <RRuleInput
                                                inputKey={this.state.datePickerKeys.rrule}
                                                startDate={reminder.start}
                                                onChangeRRule={this.onChangeRRule}
                                                originalRecurrenceObject={this.state.originalRecurrenceObject}
                                                recurrenceObject={this.state.recurrenceObject}
                                                shouldKeepUntil={this.state.shouldKeepUntil}
                                                disabled={!enableFields}
                                                rUntilDate={this.state.rUntilDate}
                                                isEditing={isEditing}
                                                isReminder={true}
                                                />
                                        </Col>
                                    </Row>
                                    {this.renderFooterButtons()}
                                </form>
                            </Col>
                        </Row>
                    </section>
                </section>
            </section>
        )
    }
}

ReminderModal.propTypes = {
    title: PropTypes.string.isRequired,
    isEditing: PropTypes.bool,
    colorData: PropTypes.any
}

const form = reduxForm({
    form: 'eventForm'
})

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        events: state.eventsReducer.events,
        recurrentEvents: state.eventsReducer.recurrentEvents,
        errorType: state.eventsReducer.errorStatus,
        updateEventsSuccess: state.eventsReducer.updateEventsSuccess,
        updateEventsError: state.eventsReducer.updateEventsError,
        errorMessage: state.eventsReducer.errorMessage,
        saving: state.eventsReducer.saving,
        loading: state.eventsReducer.loading,
        deleting: state.eventsReducer.deleting,
        deleteEventsSuccess: state.eventsReducer.deleteEventsSuccess
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        createEvent: (data) => dispatch(createEvent(data)),
        deleteEvent: (data, eventType) => dispatch(deleteEvent(data, eventType))
    }
}

export default compose(
    form,
    connect(
        mapStateToProps,
        mapDispatchToProps)
)(ReminderModal)
